/**
 * Registers a calculator directive with the given module.
 * 
 * @param {object} module - The AngularJS module to register the directive with.
 */
export default function registerCalculatorDirective(module) {
    /**
     * Registers the 'calculator' directive.
     * 
     * @returns {object} The directive definition object.
     */
    module.directive('calculator', function() {
        return {
            restrict: 'EA', // Allows the directive to be used as an element or attribute.
            replace: false, // The directive will not replace the element it is applied to.
            templateUrl: '/views/ib/modules/calculator/Calculator.html', // Path to the template used by the directive.
            controller: 'CalculatorDirectiveController', // The controller used by the directive.
        };
    });
}